import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

const Copyright: React.FC = () => {
    return (
        <Box
            sx={{
                bottom: 0,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingBottom: '2rem',
                paddingTop: '2rem',
                color: 'white',
                backgroundColor: 'rgb(24,24,24)',
                zIndex: 1000,
            }}
        >
            <Typography sx={{fontSize: '14px'}} variant="body2" color="text.secondary">
                © 2024 Moosebit. All rights reserved.
            </Typography>
        </Box>
    );
}

export default Copyright;
